import React from 'react';
import { useParams } from 'react-router-dom';
import { PaddedPageWrapper } from '../../components/atoms';
import { useGlobalContext } from '../../containers/App/context';
import FlowVersion from '../../components/FlowVersion';

const FlowVersionPage = () => {
  const { id, versionId } = useParams();
  const { getMeData, getMeRefetch } = useGlobalContext();
  const onboardingComplete = getMeData?.getOnboardingStatus === 'COMPLETE';

  if (!onboardingComplete) {
    getMeRefetch();
    return null;
  }

  if (!id) {
    return 'Missing ID';
  }

  return (
    <PaddedPageWrapper padding="0">
      <FlowVersion flowId={id} versionId={versionId} />
    </PaddedPageWrapper>
  );
};

export default FlowVersionPage;
